<template>
    <div>
        <Leftmenu />
        <Header />
        <div class="content">
            <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
            <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
            <div class="content-header">
                <Backbutton />
                Добавить пользователя в компанию
            </div>
            <div class="content-inner">
                <div class="header-for-input input_width">Введите наименование компании</div>
                <input type="text" v-model="company_name" class="content-input" @keypress="search_company()" />
                <table v-show="isTableArrayShow">
                    <tr>
                        <th>ID</th>
                        <th>Корпорация</th>
                        <th></th>
                    </tr>
                    <tr v-for="company in company_name_list" :key="company.id">
                        <td>{{company.id}}</td>
                        <td>{{company.full_name}}</td>
                        <td style="width: 100px !important;">
                            <div class="btn_for_table" @click="add_user_to_company(company.id)">Добавить</div>
                        </td>
                    </tr>
                </table>
            </div>

        </div>
    </div>
</template>

<style scoped src="../../assets/style/main.css"></style>
<style scoped src="../../assets/style/account.css"></style>
<style scoped src="../../assets/style/buttons.css"></style>


<script>
import Leftmenu from '@/components/leftmenu.vue'
import Header from '@/components/header.vue'
import Backbutton from '@/components/elements/bacl-button.vue'
import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'

export default {
    name: 'AddUserToCompany',
    components: {
        Leftmenu, Header, Backbutton, Success, Error
    },
    data() {
        return {
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
            company_name: '',
            company_name_list: {}
        }
    },
    computed: {
        isTableArrayShow: function() {
            if(this.company_name_list.length > 0)
                return true
            else    
                return false
        }
    },
    methods: {
        search_company() {
            if(this.company_name.length < 2)
                return
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.post(process.env.VUE_APP_API_URL + '/api/company/search', {
                company_name: this.company_name,
            })
            .then(response => {
                this.company_name_list = response.data.data
                loader.hide()
                this.account_info()
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        },
        add_user_to_company(company_id) {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.post(process.env.VUE_APP_API_URL + '/api/admin/user_to_company', {
                company_id: company_id,
                user_id: localStorage.getItem('user_id'),
                user_role_in_company: 1
            })
            .then(response => {
                this.operation_info = response.data.data
                this.isSuccess = true
                loader.hide()
                this.account_info()
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        }
    }
}
</script>